@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../../constants/spacing.module.less';

.wizard-modal-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: @wizard--modal-footer--background-color;

  .footer-back {
    margin-left: 0;
  }

  .footer-next {
    margin-left: @space-16;
  }

  .cancel-button {
    min-width: 70px;
    margin-right: 10px;
  }

  .icon {
    height: 10px;
    width: 20px;
  }
}
